'use client';

import type { Spacing } from '@/ui/types';
import cn from 'classnames';
import { HTMLProps, ReactNode, useRef } from 'react';

import s from './Select.module.css';

type SelectSize = 'tiny' | 'small' | 'medium' | 'large';

export type SelectProps = {
  children: ReactNode;
  width?: number;
  size?: SelectSize;
  placeholder?: string;
  spacing?: Spacing;
  disabled?: boolean;
} & Omit<HTMLProps<HTMLSelectElement>, 'size'>;

const Select = ({
  name,
  value,
  children,
  placeholder,
  size = 'medium',
  spacing,
  width,
  disabled = false,
  ...props
}: SelectProps) => {
  const element = useRef<HTMLSelectElement>(null);

  const selectWidth = width ? `${width}px` : undefined;

  return (
    <div
      className={cn(s.container, s[size], {
        [s.disabled]: disabled,
        [`spacing-${spacing}`]: !!spacing,
      })}
      style={{ width: selectWidth }}
    >
      {/* <Icon name="ChevronDown" className={s.arrow} color="gray" /> */}

      <select
        className={s.combo}
        value={value}
        name={name}
        ref={element}
        disabled={disabled}
        {...props}
      >
        {placeholder && (
          <option value={undefined} hidden>
            {placeholder}
          </option>
        )}
        {children}
      </select>
    </div>
  );
};

export default Select;
